export default "__VITE_ASSET__$Mqn42xB__"